import { render, staticRenderFns } from "./OperadoresBusca.vue?vue&type=template&id=2bfe0ea6&scoped=true"
import script from "./OperadoresBusca.vue?vue&type=script&lang=js"
export * from "./OperadoresBusca.vue?vue&type=script&lang=js"
import style0 from "./OperadoresBusca.vue?vue&type=style&index=0&id=2bfe0ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfe0ea6",
  null
  
)

export default component.exports